module.exports = __webpack_public_path__ + "static/media/ratings_grey.a06a328e.svg";